import { BehaviorSubject } from 'rxjs';
import config from '../../config/index';
import requestOptions from '@/helpers/RequestOptions';
import handleResponse from '@/helpers/HandleResponses';
import handleBlobResponse from '@/helpers/HandleBlobResponses';

export const jobService = {
    addJobProfile,
    updateJobProfile,
    getJobProfile,
    getJobProfiles,
    getJobProfession,
    getJobSkillLevels,
    addJobSkillLevel,
    addVacancy,
    activeApplicationInterviewers,
    updateVacancy,
    deleteVacancy,
    getVancancies,
    getVancanciesByOrg,
    getVancancyById,
    getVacancySummaries,
    removeJobProfiles,
    getAllApplications,
    getAllApplicationsByVacancy,
    getRejectedApplicationsByVacancy,
    getAllApplicationsByApplicant,
    getRejectedApplications,
    getAcceptedApplications,
    getApplication,
    getApplicationInterviewTime,
    getApplicationInterviewers,
    getApplicationInterviewersByEmployee,
    getApplicant,
    finishApplying,
    createApplicationInterviewScheduling,
    createApplicationScore,
    createApplicationInterviewer,
    createApplicationInterviewerFeedback,
    createApplicationNegotiation,
    createApplicationMedical,
    updateApplication,
    confirmorReschedule,
    sendScheduleRequest,
    updateApplicationScore,
    updateApplicationInterviewer,
    removeApplicationInterviewer,
    updateApplicationInterviewerFeedback,
    updateApplicationNegotiation,
    applyJob,
    downloadNewTestApplicationTemplate,
    importApplicationScore,
    sendTestMessage,
    applyJobByApplicant,
    // getJobProfileForGMD
}

// function getJobProfileForGMD() {
//     return fetch(`${config.apiurl}/Job`, requestOptions.get())
//         .then(handleResponse)
//         .then(model => {

//             return model;
//         });
// }

// function getJobProfileForGMD(companyId, departId) {
//     return fetch(`${config.apiurl}/employee/Job/${companyId}?departId=${departId}`, requestOptions.get())
//         .then(handleResponse)
//         .then(model => {
//             // console.log(model)
//             return model
//         });

// }

function addJobProfile(companyId, rankId, departmentId, title, experience, description, salaryMin, salaryMax, averageSalary, educationRequirement, educationDegree, ageLimit) {
    var load = {
        rankId,
        companyId,
        departmentId,
        title,
        experience,
        description,
        salaryMin,
        salaryMax,
        averageSalary,
        status: 1
    }
    return fetch(`${config.apiurl}/Job`, requestOptions.post(load))
        .then(handleResponse)
        .then(id => {
            var payload = {
                jobProfileId: id,
                educationRequirement,
                educationDegree,
                ageLimit
            }
            fetch(`${config.apiurl}/Job/createJobProfession`, requestOptions.post(payload))
                .then(handleResponse)
        });
}

function addJobSkillLevel(profileId, skillLevel) {
    skillLevel.jobProfileId = profileId
    return fetch(`${config.apiurl}/Job/createJobSkillLevel`, requestOptions.post(skillLevel))
        .then(handleResponse)
        .then(id => {
            return id
        });
}

function addVacancy(vacancy) {

    return fetch(`${config.apiurl}/Job/createVacancy`, requestOptions.post(vacancy))
        .then(handleResponse)
        .then(id => {
            return id
        });
}

function applyJob(id, companyId, firstName, lastName, salutation, gender, phone1, phone2, email, address, birthday, cv) {
    let formData = new FormData();
    formData.append('CompanyId', companyId);
    formData.append('FirstName', firstName);
    formData.append('LastName', lastName);
    formData.append('Salutation', salutation);
    formData.append('Gender', gender);
    formData.append('Phone1', phone1);
    formData.append('Phone2', phone2);
    formData.append('Email', email);
    formData.append('Birthday', birthday);
    formData.append('Address', address);
    formData.append('Uploadfile', cv);
    return fetch(`${config.apiurl}/application/applyJob/${id}`, requestOptions.postForm(formData))
        .then(handleResponse)
        .then(id => {
            return id
        });
}

function applyJobByApplicant(id,appid) {

    return fetch(`${config.apiurl}/application/ApplyJobWithApplicantId/${id}?appid=${appid}`, requestOptions.get())
        .then(handleResponse)
        .then(id => {
            return id
        });
}
function updateVacancy(vacancy) {

    return fetch(`${config.apiurl}/Job/updateVacancy`, requestOptions.put(vacancy))
        .then(handleResponse)
        .then(id => {
            return id
        });
}
function deleteVacancy(id) {

  return fetch(`${config.apiurl}/Job/deleteVacancy?id=${id}`, requestOptions.delete())
      .then(handleResponse)
      .then(id => {
          return id
      });
}

function updateApplication(application) {

    return fetch(`${config.apiurl}/Application/PutApplication/${application.id}`, requestOptions.put(application))
        .then(handleResponse)
        .then(id => {
            return id
        });
}

function confirmorReschedule(interview) {

    return fetch(`${config.apiurl}/Application/ConfirmorReschedule/${interview.id}`, requestOptions.put(interview))
        .then(handleResponse)
        .then(id => {
            return id
        });
}
function activeApplicationInterviewers(id) {

    return fetch(`${config.apiurl}/Application/activeApplicationInterviewers/${id}`, requestOptions.put())
        .then(handleResponse)
        .then(id => {
            return id
        });
}
function sendScheduleRequest(interview) {

    return fetch(`${config.apiurl}/Application/SendScheduleRequest/${interview.id}`, requestOptions.put(interview))
        .then(handleResponse)
        .then(id => {
            return id
        });
}

function updateApplicationInterviewer(interview) {

    return fetch(`${config.apiurl}/Application/PutApplicationInterviewer/${interview.id}`, requestOptions.put(interview))
        .then(handleResponse)
        .then(id => {
            return id
        });
}

function updateApplicationInterviewerFeedback(interview) {

    return fetch(`${config.apiurl}/Application/PutApplicationInterviewerFeedback/${interview.id}`, requestOptions.put(interview))
        .then(handleResponse)
        .then(id => {
            return id
        });
}

function updateApplicationScore(interview) {

    return fetch(`${config.apiurl}/Application/PutApplicationScore/${interview.id}`, requestOptions.put(interview))
        .then(handleResponse)
        .then(id => {
            return id
        });
}

function updateApplicationNegotiation(negotiation) {

    return fetch(`${config.apiurl}/Application/PutApplicationNegotiation/${negotiation.id}`, requestOptions.put(negotiation))
        .then(handleResponse)
        .then(id => {
            return id
        });
}

function createApplicationInterviewScheduling(applicationId, interview) {
    interview.applicationId = applicationId
    return fetch(`${config.apiurl}/application/postApplicationInterviewScheduling`, requestOptions.post(interview))
        .then(handleResponse)
        .then(id => {
            return id
        });
}

function createApplicationInterviewer(interview) {
    return fetch(`${config.apiurl}/application/postApplicationInterviewer`, requestOptions.post(interview))
        .then(handleResponse)
        .then(id => {
            return id
        });
}

function removeApplicationInterviewer(interviewerId) {
    return fetch(`${config.apiurl}/application/deleteApplicationInterviewer/${interviewerId}`, requestOptions.delete())
        .then(handleResponse)
        .then(id => {
            return id
        });
}

function createApplicationInterviewerFeedback(interview) {
    return fetch(`${config.apiurl}/application/postApplicationInterviewerFeedback`, requestOptions.post(interview))
        .then(handleResponse)
        .then(id => {
            return id
        });
}

function createApplicationScore(applicationId, interview) {
    interview.applicationId = applicationId
    return fetch(`${config.apiurl}/application/postApplicationScore`, requestOptions.post(interview))
        .then(handleResponse)
        .then(id => {
            return id
        });
}

function createApplicationMedical(applicationId, medical) {
    medical.applicationId = applicationId
    return fetch(`${config.apiurl}/application/postApplicationMedical`, requestOptions.post(medical))
        .then(handleResponse)
        .then(id => {
            return id
        });
}

function createApplicationNegotiation(applicationId, interview) {
    interview.applicationId = applicationId
    return fetch(`${config.apiurl}/application/postApplicationNegotiation`, requestOptions.post(interview))
        .then(handleResponse)
        .then(id => {
            return id
        });
}

function getVancancies(id) {
    return fetch(`${config.apiurl}/Job/getVacancies?Id=${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}

function getAllApplications(id) {
    return fetch(`${config.apiurl}/Application/GetAllApplication/${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}

function getAllApplicationsByVacancy(id) {
    return fetch(`${config.apiurl}/Application/GetAllApplicationByVacancy/${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}
function downloadNewTestApplicationTemplate(id) {
    return fetch(`${config.apiurl}/Application/DownloadApplicationTemplateTemplate/${id}`, requestOptions.get())
        .then(handleBlobResponse)
        .then(blob => {

            return blob;
        });
}
function importApplicationScore(companyId, file) {
    let formData = new FormData();
    formData.append('CompanyId', companyId);
    formData.append('File', file);
    return fetch(`${config.apiurl}/application/importApplicationScore`, requestOptions.postForm(formData))
        .then(handleResponse)
        .then(id => {
            return id
        });
}
function getRejectedApplicationsByVacancy(id) {
    return fetch(`${config.apiurl}/Application/GetRejectedApplicationByVacancy/${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}
function getAllApplicationsByApplicant(id) {
    return fetch(`${config.apiurl}/Application/GetApplicationsByApplicant/${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}

function getRejectedApplications(id) {
    return fetch(`${config.apiurl}/Application/GetRejectedApplicationByVacancy/${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}


function getAcceptedApplications(id) {
    return fetch(`${config.apiurl}/Application/GetAcceptedApplication/${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}

function getApplicationInterviewTime(id, date) {
    return fetch(`${config.apiurl}/Application/getApplicationInterviewTime/${id}?date='${date}''`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}

function getApplication(id) {
    return fetch(`${config.apiurl}/Application/GetApplicationbById/${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}

function getApplicant(email) {
    return fetch(`${config.apiurl}/Miscellaneous/GetApplicantByEmail?email=${email}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}

function getApplicationInterviewers(id) {
    return fetch(`${config.apiurl}/Application/GetApplicationInterviewers/${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}
function getApplicationInterviewersByEmployee(id) {
    return fetch(`${config.apiurl}/Application/GetApplicationInterviewersByEmployee/${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}

function finishApplying(id) {
    return fetch(`${config.apiurl}/Application/FinishApplying/${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}


function getVacancySummaries(id) {
    return fetch(`${config.apiurl}/Job/getVacancySummaries?Id=${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}

function getVancanciesByOrg() {
    return fetch(`${config.apiurl}/Job/getVacanciesByOrg`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}

function getVancancyById(id) {
    return fetch(`${config.apiurl}/Job/getVacancyById?Id=${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}



function updateJobProfile(model, professionId, educationRequirement, educationDegree, ageLimit) {

            model.jobProfession = {
                id: professionId,
                jobProfileId: model.id,
                educationRequirement,
                educationDegree,
                ageLimit
            }

            return fetch(`${config.apiurl}/Job`, requestOptions.put(model))
                .then(handleResponse)
                .then(m => {
                    return m;
                });

}

function sendTestMessage(id, title, message) {

    var req = {
        title,
        message
    }

    return fetch(`${config.apiurl}/Application/SendTestMessage/${id}`, requestOptions.post(req))
        .then(handleResponse)
        .then(m => {
            return m;
        });

}

function getJobProfile(id) {
    return fetch(`${config.apiurl}/Job?Id=${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}

function getJobSkillLevels(id) {
    return fetch(`${config.apiurl}/Job/getJobSkillLevels?Id=${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}

function getJobProfession(id) {
    return fetch(`${config.apiurl}/Job/GetJobProfessionByProfileId?id=${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}

function getJobProfiles(id) {
    return fetch(`${config.apiurl}/Job/GetJobProfiles?Id=${id}`, requestOptions.get())
                .then(handleResponse)
                .then( model => { return model })
}

function removeJobProfiles(id) {

    return fetch(`${config.apiurl}/Job?Id=${id}`, requestOptions.delete())
        .then(handleResponse)
        .then(model => {
            return model
        });

}



// WEBPACK FOOTER //
// ./src/services/jobService.js